module.exports = __webpack_public_path__ + "img/Nokia.221fbb4d.jpg";